import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { Stack, Typography, Grid, Button } from '@mui/material';
import Link from '@mui/material/Link';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment'


dayjs.extend(utc);
dayjs.extend(timezone);

// ----------------------------------------------------------------------

export default function HomePage(props) {

  return (
    <>
      <Helmet>
        <title> Home | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid style={{top: 0, width: '100%',
        display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}>

          <Grid style={{ zIndex:0, position: "absolute", top: 0, width: '100%', backgroundColor: '#1b0049', 
          backgroundImage: `url(${props.data? props.data.event_bg_fullPath : ""})`,
          backgroundPosition: 'center',
          backgroundPositionY: 0,
          backgroundSize:'cover',
          backgroundRepeat: 'no-repeat',
          height: "100%",
          display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}/>

        <Grid style={{ zIndex:1, position: "absolute", top: 0, width: '100%', backgroundColor: '#000000', 
          height: "100%",
          opacity: .7,
          display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}/>


        <Grid style={{ height: '83vh', maxWidth: 1200, zIndex:2, marginTop: 120, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column",  backgroundColor: "Transparent" }}>
            
            <Typography style={{marginTop: -10, fontSize: 20, color: 'white' }}>
            {props.data? props.data.subtitle : ""}
            </Typography>
            <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {props.data? props.data.title : ""}
            </Typography>
           
            <Typography style={{maxWidth: 500,fontWeight: 300, fontSize: 14, color: 'white', opacity: .8 }}>
            {props.data? props.data.description : ""}
            </Typography>

            <Grid container style={{ marginTop: 30 }}>
              <Grid item md={3} xs={12} style={{ display: "flex", flexDirection: "row"}}>
                <img src='/assets/calendaricon.png' alt='calendaricon' height={20}/>
                <Typography style={{ paddingLeft: 10, fontSize: 14, color: 'white' }}>
                {props.data? `${moment.utc(props.data.start_date).add(8, 'hours').format("DD/MM/YYYY")} - ${moment.utc(props.data.end_date).add(8, 'hours').format("DD/MM/YYYY")}` : ""}
                </Typography>
              </Grid>
              <Grid item md={9} xs={12} style={{ display: "flex", flexDirection: "row"}}>
              <img src='/assets/timeicon.png' alt='timeicon' height={20}/>
              <Typography style={{ paddingLeft: 10, fontSize: 14, color: 'white' }}>
                {props.data? `${moment.utc(props.data.start_time).add(8, 'hours').format("hh:mm a")} - ${moment.utc(props.data.end_time).add(8, 'hours').format("hh:mm a")}` : ""}
                </Typography>
              </Grid>
            </Grid>

            <Grid container style={{ marginTop: 10 }}>
              <Grid item md={12} xs={12} style={{ display: "flex", flexDirection: "row"}}>
                <img src='/assets/venueicon.png' alt='calendaricon' height={20}/>
                <Typography style={{ paddingLeft: 10, fontSize: 14, color: 'white' }}>
                {props.data? props.data.venue : ""}
                </Typography>
              </Grid>
            </Grid>
            
            <Link href={`/register_user/${props.data.prefix}`} style={{ textDecoration: 'none' }}>
              <Grid style={{ marginTop: 80, cursor:'pointer' }}>
                <img src='/assets/registerbtn.png' alt='register button' width={120}/>
              </Grid>
            </Link>
            
        </Grid>
        
      </Grid>
    </>
  );
}
